import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faSalesforce as freeFabFaSalesforce,
  faFontAwesomeFlag as freeFabFaFontAwesomeFlag
} from '@fortawesome/free-brands-svg-icons'

import {
  faCheck as proFarFaCheck,
  faCheckSquare as proFarFaCheckSquare,
  faQuestionCircle as proFarFaQuestionCircle,
  faSquare as proFarFaSquare,
  faStar as proFarFaStar,
  faFlag as proFarFaFlag,
  faLock as proFarFaLock,
  faPhone as proFarFaPhone,
  faEnvelope as proFarFaEnvelope,
  faVideo as proFarFaVideo,
  faBuilding as proFarFaBuilding,
  faLightbulb as proFarFaLightbulb,
  faCheckCircle as proFarFaCheckCircle
} from '@fortawesome/pro-regular-svg-icons'

import {
  faBriefcase as proFasFaBriefcase,
  faSignature as proFasFaSignature,
  faCrown as proFasFaCrown,
  faBadgeCheck as proFasFaBadgeCheck,
  faStethoscope as proFasFaStethoscope,
  faHandSparkles as proFasFaHandSparkles,
  faPersonBooth as proFasFaPersonBooth,
  faPlay as proFasFaPlay,
  faFlagCheckered as proFasFaFlagCheckered,
  faPen as proFasFaPen,
  faUser as proFasFaUser,
  faUsers as proFasFaUsers,
  faTimes as proFasFaTimes,
  faPlus as proFasFaPlus,
  faHome as proFasFaHome,
  faList as proFasFaList,
  faQuestionCircle as proFasFaQuestionCircle,
  faTasks as proFasFaTasks,
  faScrollOld as proFasFaScrollOld,
  faTable as proFasFaTable,
  faPrint as proFasFaPrint,
  faFilePdf as proFasFaFilePdf,
  faSync as proFasFaSync,
  faTrash as proFasFaTrash,
  faPlaneArrival as proFasFaPlaneArrival,
  faFlag as proFasFaFlag,
  faExpand as proFasFaExpand,
  faChevronLeft as proFasFaChevronLeft,
  faChevronRight as proFasFaChevronRight,
  faSearch as proFasFaSearch,
  faClipboardList as proFasFaClipboardList,
  faCauldron as proFasFaCauldron,
  faUserSlash as proFasFaUserSlash,
  faTrashRestore as proFasFaTrashRestore,
  faTrashUndo as proFasFaTrashUndo,
  faSave as proFasFaSave,
  faFilter as proFasFaFilter,
  faCaretDown as proFasFaCaretDown,
  faCaretUp as proFasFaCaretUp,
  faIdCard as proFasFaIdCard,
  faUserChart as proFasFaUserChart,
  faUserFriends as proFasFaUserFriends,
  faEnvelope as proFasFaEnvelope,
  faPhone as proFasFaPhone,
  faAddressCard as proFasFaAddressCard,
  faPhoneAlt as proFasFaPhoneAlt,
  faPhoneRotary as proFasFaPhoneRotary,
  faHeartbeat as proFasFaHeartbeat,
  faEdit as proFasFaEdit,
  faClock as proFasFaClock,
  faUserPlus as proFasFaUserPlus,
  faUserMd as proFasFaUserMd,
  faPrescriptionBottleAlt as proFasFaPrescriptionBottleAlt,
  faClinicMedical as proFasFaClinicMedical,
  faThumbsUp as proFasFaThumbsUp,
  faSignOutAlt as proFasFaSignOutAlt,
  faSignInAlt as proFasFaSignInAlt,
  faCog as proFasFaCog,
  faCalendar as proFasFaCalendar,
  faCalendarAlt as proFasFaCalendarAlt,
  faCalendarPlus as proFasFaCalendarPlus,
  faCircle as proFasFaCircle,
  faVideo as proFasFaVideo,
  faNewspaper as proFasFaNewspaper,
  faPaperPlane as proFasFaPaperPlane,
  faQuestion as proFasFaQuestion,
  faInfoCircle as proFasFaInfoCircle,
  faInfoSquare as proFasFaInfoSquare,
  faLightbulb as proFasFaLightbulb,
  faCircleNotch as proFasFaCircleNotch,
  faCheck as proFasFaCheck,
  faChevronUp as proFasFaChevronUp,
  faChevronDown as proFasFaChevronDown,
  faCheckSquare as proFasFaCheckSquare,
  faCheckCircle as proFasFaCheckCircle,
  faSquare as proFasFaSquare,
  faArrowsAlt as proFasFaArrowsAlt,
  faInfo as proFasFaInfo,
  faExclamation as proFasFaExclamation,
  faExclamationCircle as proFasFaExclamationCircle,
  faHouseUser as proFasFaHouseUser,
  faClipboardUser as proFasFaClipboardUser,
  faHourglassHalf as proFasFaHourglassHalf,
  faMoneyCheck as proFasFaMoneyCheck,
  faFileContract as proFasFaFileContract,
  faBinoculars as proFasFaBinoculars,
  faUndo as proFasFaUndo,
  faRedo as proFasFaRedo,
  faDownload as proFasFaDownload,
  faFileDownload as proFasFaFileDownload,
  faUpload as proFasFaUpload,
  faH1 as proFasFaH1,
  faH2 as proFasFaH2,
  faH3 as proFasFaH3,
  faParagraph as proFasFaParagraph,
  faChartBar as proFasFaChartBar,
  faBold as proFasFaBold,
  faItalic as proFasFaItalic,
  faStrikethrough as proFasFaStrikethrough,
  faStar as proFasFaStar,
  faStarHalfAlt as proFasFaStarHalfAlt,
  faAlignLeft as proFasFaAlignLeft,
  faAlignRight as proFasFaAlignRight,
  faAlignCenter as proFasFaAlignCenter,
  faAlignJustify as proFasFaAlignJustify,
  faListUl as proFasFaListUl,
  faListOl as proFasFaListOl,
  faCode as proFasFaCode,
  faQuoteLeft as proFasFaQuoteLeft,
  faLink as proFasFaLink,
  faUnlink as proFasFaUnlink,
  faHorizontalRule as proFasFaHorizontalRule,
  faTerminal as proFasFaTerminal,
  faExclamationTriangle as proFasFaExclamationTriangle,
  faCity as proFasFaCity,
  faSackDollar as proFasFaSackDollar,
  faChartLine as proFasFaChartLine,
  faStore as proFasFaStore,
  faDollarSign as proFasFaDollarSign,
  faHatWizard as proFasFaHatWizard,
  faLock as proFasFaLock,
  faShieldCheck as proFasFaShieldCheck,
  faStopwatch as proFasFaStopwatch,
  faGavel as proFasFaGavel,
  faStreetView as proFasFaStreetView,
  faShieldAlt as proFasFaShieldAlt,
  faCopy as proFasFaCopy,
  faPaste as proFasFaPaste,
  faArrowToBottom as proFasFaArrowToBottom,
  faHighlighter as proFasFaHighlighter,
  faFileCode as proFasFaFileCode,
  faFont as proFasFaFont,
  faFolder as proFasFaFolder,
  faUnderline as proFasFaUnderline,
  faRectangleWide as proFasFaRectangleWide,
  faMicrophone as proFasFaMicrophone,
  faMicrophoneSlash as proFasFaMicrophoneSlash,
  faPaperclip as proFasFaPaperclip,
  faExternalLink as proFasFaExternalLink,
  faExternalLinkAlt as proFasFaExternalLinkAlt,
  faSpinner as proFasFaSpinner
} from '@fortawesome/pro-solid-svg-icons'

import {
  faRectangleWide as proFadFaRectangleWide
} from '@fortawesome/pro-duotone-svg-icons'

import {
  faCapsules as proFalFaCapsules,
  faMemoPad as proFalFaMemoPad
} from '@fortawesome/pro-light-svg-icons'

library.add(
  freeFabFaSalesforce,
  freeFabFaFontAwesomeFlag,
  proFarFaCheck,
  proFarFaCheckSquare,
  proFarFaQuestionCircle,
  proFarFaSquare,
  proFarFaStar,
  proFarFaFlag,
  proFarFaLock,
  proFarFaPhone,
  proFarFaEnvelope,
  proFarFaVideo,
  proFarFaBuilding,
  proFarFaLightbulb,
  proFarFaCheckCircle,
  proFasFaBriefcase,
  proFasFaSignature,
  proFasFaCrown,
  proFasFaBadgeCheck,
  proFasFaStethoscope,
  proFasFaHandSparkles,
  proFasFaPersonBooth,
  proFasFaPlay,
  proFasFaFlagCheckered,
  proFasFaPen,
  proFasFaUser,
  proFasFaUsers,
  proFasFaTimes,
  proFasFaPlus,
  proFasFaHome,
  proFasFaList,
  proFasFaQuestionCircle,
  proFasFaTasks,
  proFasFaScrollOld,
  proFasFaTable,
  proFasFaPrint,
  proFasFaFilePdf,
  proFasFaSync,
  proFasFaTrash,
  proFasFaPlaneArrival,
  proFasFaFlag,
  proFasFaExpand,
  proFasFaChevronLeft,
  proFasFaChevronRight,
  proFasFaSearch,
  proFasFaClipboardList,
  proFasFaCauldron,
  proFasFaUserSlash,
  proFasFaTrashRestore,
  proFasFaTrashUndo,
  proFasFaSave,
  proFasFaFilter,
  proFasFaCaretDown,
  proFasFaCaretUp,
  proFasFaIdCard,
  proFasFaUserChart,
  proFasFaUserFriends,
  proFasFaEnvelope,
  proFasFaPhone,
  proFasFaAddressCard,
  proFasFaPhoneAlt,
  proFasFaPhoneRotary,
  proFasFaHeartbeat,
  proFasFaEdit,
  proFasFaClock,
  proFasFaUserPlus,
  proFasFaUserMd,
  proFasFaPrescriptionBottleAlt,
  proFasFaClinicMedical,
  proFasFaThumbsUp,
  proFasFaSignOutAlt,
  proFasFaSignInAlt,
  proFasFaCog,
  proFasFaCalendar,
  proFasFaCalendarAlt,
  proFasFaCalendarPlus,
  proFasFaCircle,
  proFasFaVideo,
  proFasFaNewspaper,
  proFasFaPaperPlane,
  proFasFaQuestion,
  proFasFaInfoCircle,
  proFasFaInfoSquare,
  proFasFaLightbulb,
  proFasFaCircleNotch,
  proFasFaCheck,
  proFasFaChevronUp,
  proFasFaChevronDown,
  proFasFaCheckSquare,
  proFasFaCheckCircle,
  proFasFaSquare,
  proFasFaArrowsAlt,
  proFasFaInfo,
  proFasFaExclamation,
  proFasFaExclamationCircle,
  proFasFaHouseUser,
  proFasFaClipboardUser,
  proFasFaHourglassHalf,
  proFasFaMoneyCheck,
  proFasFaFileContract,
  proFasFaBinoculars,
  proFasFaUndo,
  proFasFaRedo,
  proFasFaDownload,
  proFasFaFileDownload,
  proFasFaUpload,
  proFasFaH1,
  proFasFaH2,
  proFasFaH3,
  proFasFaParagraph,
  proFasFaChartBar,
  proFasFaBold,
  proFasFaItalic,
  proFasFaStrikethrough,
  proFasFaStar,
  proFasFaStarHalfAlt,
  proFasFaAlignLeft,
  proFasFaAlignRight,
  proFasFaAlignCenter,
  proFasFaAlignJustify,
  proFasFaListUl,
  proFasFaListOl,
  proFasFaCode,
  proFasFaQuoteLeft,
  proFasFaLink,
  proFasFaUnlink,
  proFasFaHorizontalRule,
  proFasFaTerminal,
  proFasFaExclamationTriangle,
  proFasFaCity,
  proFasFaSackDollar,
  proFasFaChartLine,
  proFasFaStore,
  proFasFaDollarSign,
  proFasFaHatWizard,
  proFasFaLock,
  proFasFaShieldCheck,
  proFasFaStopwatch,
  proFasFaGavel,
  proFasFaStreetView,
  proFasFaShieldAlt,
  proFasFaCopy,
  proFasFaPaste,
  proFasFaArrowToBottom,
  proFasFaHighlighter,
  proFasFaFileCode,
  proFasFaFont,
  proFasFaFolder,
  proFasFaUnderline,
  proFasFaRectangleWide,
  proFasFaMicrophone,
  proFasFaMicrophoneSlash,
  proFasFaPaperclip,
  proFasFaExternalLink,
  proFasFaExternalLinkAlt,
  proFasFaSpinner,
  proFadFaRectangleWide,
  proFalFaCapsules,
  proFalFaMemoPad
)

config.autoAddCss = false

Vue.component('fa', FontAwesomeIcon)
Vue.component('faLayers', FontAwesomeLayers)
Vue.component('faLayersText', FontAwesomeLayersText)
